module.exports = __webpack_public_path__ + "assets/ff802be6622d4f71f5c9cf3f07ab9c00.png";